// Ridimensiona e ricodifica in JPEG sul telefono: meno peso, nessun metadato EXIF/GPS, dettagli conservati.
const MAX_SIDE = 2048;

const loadBitmap = async (file) => {
  try {
    return await createImageBitmap(file, { imageOrientation: "from-image" });
  } catch {
    const url = URL.createObjectURL(file);
    const img = await new Promise((ok, ko) => { const i = new Image(); i.onload = () => ok(i); i.onerror = ko; i.src = url; });
    URL.revokeObjectURL(url);
    return img;
  }
};

const toJpeg = (canvas, quality) => new Promise((ok) => canvas.toBlob(ok, "image/jpeg", quality));

const draw = async (src, sx, sy, sw, sh, quality) => {
  const scale = Math.min(1, MAX_SIDE / Math.max(sw, sh));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(sw * scale);
  canvas.height = Math.round(sh * scale);
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(src, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
  return toJpeg(canvas, quality);
};

export async function compressImage(file) {
  try {
    const bmp = await loadBitmap(file);
    const blob = await draw(bmp, 0, 0, bmp.width, bmp.height, 0.9);
    return blob && blob.size < file.size ? new File([blob], "foto.jpg", { type: "image/jpeg" }) : file;
  } catch {
    return file;
  }
}

export async function cropImage(file, area) {
  const bmp = await loadBitmap(file);
  const blob = await draw(bmp, area.x, area.y, area.width, area.height, 0.95);
  return new File([blob], "ritaglio.jpg", { type: "image/jpeg" });
}

const key = (aid) => `upload_ms_${aid}`;
export const addUploadTime = (aid, ms) => sessionStorage.setItem(key(aid), String((Number(sessionStorage.getItem(key(aid))) || 0) + ms));
export const takeUploadTime = (aid) => {
  const v = Number(sessionStorage.getItem(key(aid))) || null;
  sessionStorage.removeItem(key(aid));
  return v;
};
